<div class="surface-section min-h-screen bg-gray-50">
    <p-toast [life]="5000" />
    <!-- Header -->
    <div
        class="flex flex-column lg:flex-row lg:justify-content-between lg:align-items-start p-4 bg-white border-bottom-1 surface-border">
        <div class="flex align-items-start gap-3">
            <button pButton icon="pi pi-arrow-left" (click)="goBack()"
                class="p-button-text p-button-rounded p-button-lg" [disabled]="loading">
            </button>
            <div class="flex-1">
                <div class="flex align-items-center gap-3 mb-1">
                    <h1 class="text-2xl font-bold m-0 text-900" *ngIf="!loading">
                        {{ sequence?.name }}
                    </h1>
                    <p-skeleton *ngIf="loading" width="250px" height="2rem"></p-skeleton>
                    <p-tag *ngIf="!loading && sequence" [value]="capitalizeFirst(sequence.status)"
                        [severity]="getStatusSeverity()" styleClass="text-sm font-medium">
                    </p-tag>
                    <p-skeleton *ngIf="loading" width="60px" height="1.5rem"></p-skeleton>
                </div>
                <div *ngIf="!loading" class="text-primary">
                    <p class="m-0 mb-1 font-medium">{{sequence?.name}}</p>
                    <p class="m-0 text-sm text-primary">Sender: {{sequence?.sender}}</p>
                    <app-strategy-route-chip [companyId]="sequence?.companyId" [providerCampaignId]="sequence?.providerCampaignId"></app-strategy-route-chip>
                </div>
                <div *ngIf="loading">
                    <p-skeleton width="220px" height="1rem" class="mb-1"></p-skeleton>
                    <p-skeleton width="120px" height="1rem"></p-skeleton>
                </div>
            </div>
        </div>
        <div class="mt-3 lg:mt-0 text-right" *ngIf="!loading && sequence">
            <p class="text-600 text-sm m-0">Created: {{ sequence.createdAt | date:'MMMM d, yyyy' }}</p>
            <p class="text-600 text-sm m-0 mt-1">{{ sequence.numSteps }} steps in sequence</p>
        </div>
        <div *ngIf="loading" class="mt-3 lg:mt-0">
            <p-skeleton width="150px" height="1rem" class="mb-1"></p-skeleton>
            <p-skeleton width="120px" height="1rem"></p-skeleton>
        </div>
    </div>

    <div class="p-4">
        <!-- Key Performance Indicators -->
        <div class="grid mb-4" *ngIf="!loading">
            <!-- Total Sent -->
            <div class="col-12 md:col-3">
                <div class="bg-white border-round p-4 border-1 surface-border h-full">
                    <div class="flex align-items-center">
                        <div
                            class="bg-blue-50 border-circle w-3rem h-3rem flex align-items-center justify-content-center mr-3">
                            <i class="pi pi-users text-blue-500 text-xl"></i>
                        </div>
                        <div>
                            <p class="text-600 text-sm m-0 mb-1">Total Connections Sent</p>
                            <p class="text-4xl font-bold text-900 m-0">{{ formatNumber(getTotalSent()) }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Connections -->
            <div class="col-12 md:col-3">
                <div class="bg-white border-round p-4 border-1 surface-border h-full">
                    <div class="flex align-items-center">
                        <div
                            class="bg-green-50 border-circle w-3rem h-3rem flex align-items-center justify-content-center mr-3">
                            <i class="pi pi-link text-green-500 text-xl"></i>
                        </div>
                        <div>
                            <p class="text-600 text-sm m-0 mb-1">{{ platformType === 'linkedin' ? 'Connections' :
                                'Opens' }}</p>
                            <p class="text-4xl font-bold text-900 m-0">{{ formatNumber(getConnections()) }}</p>
                            <p class="text-green-600 text-sm m-0">{{ formatPercentage(getConnectionRate()) }} rate</p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Responses -->
            <div class="col-12 md:col-3">
                <div class="bg-white border-round p-4 border-1 surface-border h-full">
                    <div class="flex align-items-center">
                        <div
                            class="bg-purple-50 border-circle w-3rem h-3rem flex align-items-center justify-content-center mr-3">
                            <i class="pi pi-comment text-purple-500 text-xl"></i>
                        </div>
                        <div>
                            <p class="text-600 text-sm m-0 mb-1">Responses</p>
                            <p class="text-4xl font-bold text-900 m-0">{{ formatNumber(getResponses()) }}</p>
                            <p class="text-purple-600 text-sm m-0">{{ formatPercentage(getResponseRate()) }} rate</p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Meetings -->
            <div class="col-12 md:col-3">
                <div class="bg-white border-round p-4 border-1 surface-border h-full">
                    <div class="flex align-items-center">
                        <div
                            class="bg-orange-50 border-circle w-3rem h-3rem flex align-items-center justify-content-center mr-3">
                            <i class="pi pi-trending-up text-orange-500 text-xl"></i>
                        </div>
                        <div>
                            <p class="text-600 text-sm m-0 mb-1">Meetings</p>
                            <p class="text-4xl font-bold text-900 m-0">{{ formatNumber(getMeetings()) }}</p>
                            <p class="text-orange-600 text-sm m-0">{{ formatPercentage(getMeetingConversionRate()) }}
                                conversion</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Loading state for KPIs -->
        <div class="grid mb-4" *ngIf="loading">
            <div class="col-12 md:col-3" *ngFor="let item of [1,2,3,4]">
                <div class="bg-white border-round p-4 border-1 surface-border h-full">
                    <div class="flex align-items-center">
                        <p-skeleton shape="circle" size="3rem" class="mr-3"></p-skeleton>
                        <div class="flex-1">
                            <p-skeleton width="60px" height="1rem" class="mb-2"></p-skeleton>
                            <p-skeleton width="40px" height="2.5rem" class="mb-1"></p-skeleton>
                            <p-skeleton width="80px" height="0.8rem"></p-skeleton>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Main Content Grid -->
        <div class="grid" *ngIf="!loading">
            <!-- Conversion Funnel -->
            <div class="col-12 lg:col-8">
                <div class="bg-white border-round p-4 border-1 surface-border h-full">
                    <div class="flex align-items-center mb-4">
                        <i class="pi pi-chart-line text-900 text-xl mr-2"></i>
                        <h3 class="text-xl font-bold text-900 m-0">Conversion Funnel</h3>
                    </div>

                    <div class="funnel-steps">


                        <!-- Connections Made -->
                        <div class="flex justify-content-between align-items-center p-3 mb-2 bg-green-50 border-round">
                            <span class="text-900 font-semibold">{{ platformType === 'linkedin' ? 'Connections Made' :
                                'Emails Opened' }}</span>
                            <div class="text-right">
                                <span class="text-green-600 font-bold text-xl mr-2">{{ formatNumber(getConnections())
                                    }}</span>
                                <span class="text-green-600 font-semibold">({{ formatPercentage(getConnectionRate())
                                    }})</span>
                            </div>
                        </div>
                        <!-- Messages Sent -->
                        <div class="flex justify-content-between align-items-center p-3 mb-2 bg-blue-50 border-round">
                            <span class="text-900 font-semibold">{{ platformType === 'linkedin' ? 'Messages Sent' :
                                'Emails Sent' }}</span>
                            <span class="text-blue-600 font-bold text-xl">{{ formatNumber(getTotalMessagesSent())
                                }}</span>
                        </div>
                        <!-- Responses Received -->
                        <div class="flex justify-content-between align-items-center p-3 mb-2 bg-purple-50 border-round">
                            <span class="text-900 font-semibold">Responses Received</span>
                            <div class="text-right">
                                <span class="text-purple-600 font-bold text-xl mr-2">{{ formatNumber(getResponses())
                                    }}</span>
                                <span class="text-purple-600 font-semibold">({{ formatPercentage(getResponseRate())
                                    }})</span>
                            </div>
                        </div>

                        <!-- Meetings Scheduled -->
                        <div class="flex justify-content-between align-items-center p-3 bg-orange-50 border-round">
                            <span class="text-900 font-semibold">Meetings Scheduled</span>
                            <div class="text-right">
                                <span class="text-orange-600 font-bold text-xl mr-2">{{ formatNumber(getMeetings())
                                    }}</span>
                                <span class="text-orange-600 font-semibold">({{
                                    formatPercentage(getMeetingConversionRate()) }})</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Sequence Performance -->
            <div class="col-12 lg:col-4">
                <div class="bg-white border-round p-4 border-1 surface-border h-full">
                    <div class="flex align-items-center mb-4">
                        <i class="pi pi-chart-bar text-900 text-xl mr-2"></i>
                        <h3 class="text-xl font-bold text-900 m-0">Sequence Performance</h3>
                    </div>

                    <div class="performance-stats">
                        <!-- Sequence Status -->
                        <div
                            class="flex justify-content-between align-items-center py-3 border-bottom-1 surface-border">
                            <span class="text-600 font-medium">Sequence Status</span>
                            <p-tag [value]="capitalizeFirst(sequence?.status || 'Active')" severity="success"
                                styleClass="font-semibold">
                            </p-tag>
                        </div>

                        <!-- Steps in Sequence -->
                        <div
                            class="flex justify-content-between align-items-center py-3 border-bottom-1 surface-border">
                            <span class="text-600 font-medium">Steps in Sequence</span>
                            <span class="text-900 font-bold">{{ sequence?.numSteps || 3 }}</span>
                        </div>

                        <!-- A/B Tests Active -->
                        <!-- <div
                            class="flex justify-content-between align-items-center py-3 border-bottom-1 surface-border">
                            <span class="text-600 font-medium">A/B Tests Active</span>
                            <span class="text-900 font-bold">1</span>
                        </div> -->

                        <!-- Created Date -->
                        <div
                            class="flex justify-content-between align-items-center py-3 border-bottom-1 surface-border">
                            <span class="text-600 font-medium">Created Date</span>
                            <span class="text-900 font-bold">{{ sequence?.createdAt | date:'MMMM d, yyyy' }}</span>
                        </div>

                        <!-- Description -->
                        <div class="mt-4" *ngIf="sequence?.description">
                            <p class="text-600 font-medium text-sm m-0 mb-2">Description</p>
                            <p class="text-900 font-semibold m-0">{{ sequence?.description }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Loading state for main content -->
        <div class="grid" *ngIf="loading">
            <div class="col-12 lg:col-8">
                <div class="bg-white border-round p-4 border-1 surface-border h-full">
                    <p-skeleton width="200px" height="1.5rem" class="mb-4"></p-skeleton>
                    <div *ngFor="let item of [1,2,3,4]" class="mb-3">
                        <div class="bg-gray-50 border-round p-3">
                            <div class="flex justify-content-between align-items-center">
                                <p-skeleton width="150px" height="1rem"></p-skeleton>
                                <p-skeleton width="80px" height="1.5rem"></p-skeleton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-4">
                <div class="bg-white border-round p-4 border-1 surface-border h-full">
                    <p-skeleton width="180px" height="1.5rem" class="mb-4"></p-skeleton>
                    <div *ngFor="let item of [1,2,3,4,5]" class="mb-3">
                        <div class="flex justify-content-between align-items-center py-2">
                            <p-skeleton width="120px" height="1rem"></p-skeleton>
                            <p-skeleton width="60px" height="1rem"></p-skeleton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>